import React, { ReactNode } from 'react';

import { FooterSocialLinkType } from 'types/studio/footer';

import { FacebookIcon, InstagramIcon, TikTokIcon, TwitterIcon, YouTubeIcon } from '@ag1/ui';
import styles from './styles.module.scss';

const icons: Record<FooterSocialLinkType['social'], ReactNode> = {
  facebook: <FacebookIcon />,
  instagram: <InstagramIcon />,
  tiktok: <TikTokIcon />,
  twitter: <TwitterIcon />,
  youtube: <YouTubeIcon />
};

const FooterSocialLink = ({ social, link }: FooterSocialLinkType) => (
  <a
    href={link}
    target="_blank"
    rel="noopener noreferrer"
    className={styles.link}
    aria-label="Opens in a new tab">
    {icons[social]}
  </a>
);

export default FooterSocialLink;
